module.exports = __webpack_public_path__ + "assets/img/Type BS (10).7f6352af.jpg";